import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, Card, Col, Form, Row } from 'react-bootstrap';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Fetcher } from "../../Helpers/fetcher.js";
import { Redirect } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Notify } from "../../Helpers/notification.js";
import { cloneDeep, isEmpty, isNull } from 'lodash';
import Cookies from 'js-cookie';
import "./index.css"
import { STATUS_CODE_TO_LABEL, TEMPLATES } from "../../Helpers/constant.js";
import { TcdHeaderFormatter } from "../../Helpers/tooltip.js";

const defaultSorted = [{
    dataField: 'userId',
    order: 'desc'
}]

const { ExportCSVButton } = CSVExport;

export default class ResellerSummary extends Component{

    constructor(props){

        super(props);

        this.state = {
            list: [],
            summaryList: [],
            username: '',
            startDate: '',
            endDate: '',
            noDataDisplayMsg: '',
            resellerUserList : [],
            userParentType : '',
            sizePerPage: 10,
            isLoading: true,
            billingDurationData: null,
            showBillingModal: false,
            loadingBilling: false
        }

    }

    closeBillingModal = () => {
        this.setState({ showBillingModal: false, billingDurationData: null });
    }

    handleStartDateChange = (date) => {
               this.setState({
                   startDate: date,
            });
     };

     handleEndDateChange = (date) => {
               this.setState({
                   endDate: date,
            });
     };


     setvalue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    componentDidMount() {
        this.getSummary();
        
        this.getResellersummaryUsers();

        this.getUserProfile();
        const savedSizePerPage = Cookies.get('resellerSummaryListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }

    }

    getUserProfile = () => {

        const apiPath = this.props.app.apiPath;
        const userId = this.props.app.userId;
        Fetcher.get(apiPath + '/api/obd/user/profile/'+userId)
            .then(res => {
                this.setState({
                    userParentType : res.parentType
                })
            })
            .catch(err => { console.log('Error in fetching user profile', err) });

    }

    getResellersummaryUsers = () => {
        
        const apiPath = this.props.app.apiPath;
        const userId = this.props.app.userId;
        Fetcher.get(apiPath + '/api/obd/reseller/users/'+userId)
            .then(res => {
                this.setState({
                    resellerUserList: res.sort( (val1,val2) => {
                        if(val1.username > val2.username) return 1;
                        else if(val1.username < val2.username) return -1;
                        else return 0;
                    } )
                })
            })
            .catch(err => { console.log('Error in fetching Reseller Users List', err) });

    }

    getSummary = () => {
        const userId = this.props.app.userId;
        const data = {
            userId:userId,
            startDate : this.state.startDate,
            endDate : this.state.endDate,
            username: this.state.username
        }
        
       return Fetcher.post(this.props.app.apiPath + '/api/obd/reseller/summary', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
            .then(res => {
                console.log(res);
                this.setState({
                    summaryList: res
                })
            })
            .catch(err => {
                console.log('Error in Registering Account', err)
                Notify.notify('Error in Registering Account');
            })
            .finally(() => this.setState({ isLoading: false }));

    }

    // fetchBillingDuration = (campaignId) => {
    //     this.setState({ loadingBilling: true });
        
    //     const apiPath = this.props.app.apiPath;
        
    //     Fetcher.get(apiPath + `/api/obd/campaign/billing/duration/${campaignId}`)
    //     .then(res => {
    //         this.setState({
    //             billingDurationData: res,
    //             showBillingModal: true,
    //             loadingBilling: false
    //         });
    //     })
    //     .catch(err => {
    //         console.log('Error fetching billing duration', err);
    //         Notify.notify('Error fetching billing duration');
    //         this.setState({ loadingBilling: false });
    //     });
    // }

    formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

    searchCdr = async (e) => {
        e.preventDefault();
        let sDate = "";
        let eDate ="";
        if(this.state.startDate === ""){
                 sDate = this.state.startDate
        }else{
            sDate =  this.formatDate(this.state.startDate)
        }
        if(this.state.endDate === ""){
                 eDate = this.state.endDate
        }else{
            eDate =  this.formatDate(this.state.endDate)
        }

        const userId = this.props.app.userId;

        const data = {
            username: this.state.username,
            startDate: sDate,
            endDate: eDate,
            userId: userId
        }

        this.setState({ isLoading: true, summaryList: [] });
        return Fetcher.post(this.props.app.apiPath + '/api/obd/reseller/summary', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
            .then(res => {
                this.setState({'summaryList': res});
                if(res.length == 0) this.setState({noDataDisplayMsg: 'No records found'});
            })
            .catch(err => {
                console.log('Error in fetching call detail records: ', err);
                Notify.notify('Error in fetching call detail records');
            })
            .finally(() => this.setState({ isLoading: false }));
    }

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('resellerSummaryListsizePerPage', newSizePerPage);
    }
    
    render() {

        console.log("********"+this.state.userParentType);
        const list = this.state.list;
        const summaryList = this.state.summaryList;
        let columns = [];
        if(this.state.userParentType === "reseller") {
         columns = [
            {
                dataField: 'reseller1_username',
                text: 'Reseller2 Username',
                sort: true,
                searchable: true
            },            {
                dataField: 'reseller1_plan',
                text: 'Reseller2 Plan',
                sort: true,
                searchable: true
            },
            {
                dataField: 'username',
                text: 'Username',
                sort: true,
                searchable: true
            },
             {
                dataField: 'templateId',
                text: 'Campaign Type',
                sort: true,
                searchable: true
             },
            {
                dataField: 'pulseduration',
                text: 'Pulse Duration',
                sort: false,
                searchable: false
            },
            {
                dataField: 'pulse_rate',
                text: 'Pulse Price',
                sort: false,
                searchable: false
            },
            {
                dataField: 'campaign_name',
                text: 'Campaign Name',
                sort: true,
                searchable: true
            },
            {
                dataField: 'campaign_start_date',
                text: 'Campaign Start Date',
                sort: false,
                searchable: false
            },
            {
                dataField: 'campaign_end_date',
                text: 'Campaign End Date',
                sort: false,
                searchable: false
            },
            {
                dataField: 'campaign_status',
                text: 'Campaign Status',
                sort: true,
                searchable: true
            },
            {
                dataField: 'totalCallsDialed',
                text: 'TCD',
                headerFormatter: () => (
                    <TcdHeaderFormatter
                        id="tcd-tooltip"
                        text="TCD"
                        tooltip="Total Calls Dialed (Calls Dialed + Retry Count)"
                    />),
                sort: false,
                searchable: false,
                headerStyle: { minWidth: "90px" }
            },
            {
                dataField: 'calls_dialed',
                text: 'Calls Dialed',
                sort: false,
                searchable: false
            },
            {
                dataField: 'retryCount',
                text: 'Rerty Count',
                sort: false,
                searchable: false
            },
            {
                dataField: 'connected_calls',
                text: 'Connected Calls',
                sort: false,
                searchable: false
            },
            {
                dataField: 'reseller1_pulse',
                text: 'Reseller2 Pulse',
                sort: false,
                searchable: false
            },
            {
                dataField: 'user_pulse',
                text: 'User Pulse',
                sort: false,
                searchable: false
            },
            {
                dataField: 'sms_count',
                text: 'User SMS Count',
                sort: false,
                searchable: false
            }
        ];}
        else{

            columns = [
            {
                dataField: 'reseller2_username',
                text: 'Reseller1 Username',
                sort: true,
                searchable: true
            },
            {
                dataField: 'reseller2_plan',
                text: 'Reseller1 Plan',
                sort: true,
                searchable: true
            },
            {
                dataField: 'reseller2_pulse',
                text: 'Reseller1 Pulse',
                sort: false,
                searchable: false
            },
            {
                dataField: 'reseller1_username',
                text: 'Reseller2 Username',
                sort: true,
                searchable: true
            },            {
                dataField: 'reseller1_plan',
                text: 'Reseller2 Plan',
                sort: true,
                searchable: true
            },
            {
                dataField: 'username',
                text: 'Username',
                sort: true,
                searchable: true
            },
            {
                dataField: 'templateId',
                text: 'Campaign Type',
                sort: true,
                searchable: true
            },
            {
                dataField: 'pulseduration',
                text: 'Pulse Duration',
                sort: false,
                searchable: false
            },
            {
                dataField: 'pulse_rate',
                text: 'Pulse Price',
                sort: false,
                searchable: false
            },
            {
                dataField: 'campaign_name',
                text: 'Campaign Name',
                sort: true,
                searchable: true
            },
            {
                dataField: 'campaign_start_date',
                text: 'Campaign Start Date',
                sort: false,
                searchable: false
            },
            {
                dataField: 'campaign_end_date',
                text: 'Campaign End Date',
                sort: false,
                searchable: false
            },
            {
                dataField: 'campaign_status',
                text: 'Campaign Status',
                sort: true,
                searchable: true
            },
            {
                dataField: 'totalCallsDialed',
                text: 'TCD',
                headerFormatter: () => (
                    <TcdHeaderFormatter
                        id="tcd-tooltip"
                        text="TCD"
                        tooltip="Total Calls Dialed (Calls Dialed + Retry Count)"
                    />),
                sort: false,
                searchable: false,
                headerStyle: { minWidth: "90px" }
            },
            {
                dataField: 'calls_dialed',
                text: 'Calls Dialed',
                sort: false,
                searchable: false
            },
            {
                dataField: 'retryCount',
                text: 'Rerty Count',
                sort: false,
                searchable: false
            },
            {
                dataField: 'connected_calls',
                text: 'Connected Calls',
                sort: false,
                searchable: false
            },
            {
                dataField: 'reseller1_pulse',
                text: 'Reseller2 Pulse',
                sort: false,
                searchable: false
            },
            {
                dataField: 'user_pulse',
                text: 'User Pulse',
                sort: false,
                searchable: false
            },
            {
                dataField: 'sms_count',
                text: 'User SMS Count',
                sort: false,
                searchable: false
            },
            {
                dataField: 'ttsCount',
                text: 'Total Variable Count',
                sort: false,
                searchable: false
            }
            // ,
            // {
            //     dataField: 'campaignId',
            //     text: 'Billing Duration',
            //     sort: false,
            //     searchable: false,
            //     classes: 'billing-duration-column',
            //     headerStyle: { width: '130px', minWidth: '130px', maxWidth: '130px' },
            //     style: { width: '130px', minWidth: '130px', maxWidth: '130px' },
            //     formatter: (cell, row) => {
            //         return <Button
            //             onClick={() => this.fetchBillingDuration(cell)}
            //             disabled={this.state.loadingBilling}
            //         >
            //             Check Duration
            //         </Button>
            //     },
            // }
        ];
        }

        let summary = undefined;
        if(this.state.userParentType === "reseller"){
         summary = Array.isArray(summaryList) ? summaryList.map((user, index) => {
            const status = STATUS_CODE_TO_LABEL[user.campaignStatus] ?? '';
            let template = TEMPLATES[user.templateId]??""
            const callsDialed = Number(user.callsDailed) || 0;
            const retryCount = Number(user.retryCount) || 0;
            return {
                    reseller2_username: user.reseller2Username,
                    reseller2_plan: user.reseller2PlanName,
                    reseller1_username: user.reseller1Username,
                    reseller1_plan: user.reseller1PlanName,
                    username: user.username,
                    pulseduration: user.userPulseDuration,
                    pulse_rate: user.userPulsePrice,
                    campaign_name: user.campaignName,
                    campaign_start_date: user.scheduleDate,
                    campaign_end_date: user.endDate,
                    campaign_status: status,
                    calls_dialed: callsDialed,
                    retryCount: retryCount,
                    totalCallsDialed: callsDialed + retryCount,
                    connected_calls: user.callsConnected,
                    reseller2_pulse : user.reseller2Pulses,
                    reseller1_pulse : user.reseller1Pulses,
                    user_pulse: user.userPulses,
                    sms_count : user.smsCount,
                    templateId: template,
                };
            }
         ) : []
        }else{

            summary = Array.isArray(summaryList) ? summaryList.map((user, index) => {
            const status = STATUS_CODE_TO_LABEL[user.campaignStatus] ?? '';
            let template = TEMPLATES[user.templateId]??""
            const callsDialed = Number(user.callsDailed) || 0;
            const retryCount = Number(user.retryCount) || 0;
            return {
                    reseller1_username: user.reseller1Username,
                    reseller1_plan: user.reseller1PlanName,
                    reseller1_pulse: user.reseller1Pulses,
                    reseller2_username: user.reseller2Username,
                    reseller2_plan: user.reseller2PlanName,
                    username: user.username,
                    pulseduration: user.userPulseDuration,
                    pulse_rate: user.userPulsePrice,
                    campaign_name: user.campaignName,
                    campaign_start_date: user.scheduleDate,
                    campaign_end_date: user.endDate,
                    campaign_status: status,
                    calls_dialed: callsDialed,
                    retryCount: retryCount,
                    totalCallsDialed: callsDialed + retryCount,
                    connected_calls: user.callsConnected,
                    reseller2_pulse : user.reseller2Pulses,
                    user_pulse: user.userPulses,
                    sms_count : user.smsCount,
                    campaignId : user.campaignId,
                    ttsCount : user.ttsCount,
                    templateId: template,
                };
            }
         ) : []

        }
        
        const paginationOption = {
            custom: true,
            totalSize: summary.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        }

        const { SearchBar, ClearSearchButton } = Search;

        const resellerUsersList = cloneDeep(this.state.resellerUserList);
        let usersDropdown = '';
        if (!isEmpty(resellerUsersList) && (!('error' in resellerUsersList))) {
            usersDropdown = Array.isArray(resellerUsersList) ? resellerUsersList.map((obj, index) => {
                return <option value={obj.username} key={`planid${index}`} >{obj.username}</option>
            }) : []

        } else {
            usersDropdown = <option value="" >No User found</option>
        }

        return( <Card>

            <Card.Header>Reseller Summary List</Card.Header>

            <Card.Body>
                    <div className="user-list-table-cont">
                        
                    <Form className="add-campaign-form" method='post' onSubmit={(e) => this.searchCdr(e)}>
                        <Row>
                            <Col sm={3}>
                                <Form.Group className="form-group  control-label">
                                    <Form.Select className="dd" name="username" onChange={e => this.setvalue(e)} as="select">
                                        <option value="">Select User</option>
                                        {usersDropdown}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col sm={2}>
                                <Form.Group className="form-group">
                                    <DatePicker
                                        className="form-control"
                                        dateFormat="yyyy-MM-dd"
                                        selected={this.state.startDate}
                                        onChange={this.handleStartDateChange}
                                        placeholderText="Start Date"
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={2}>
                                <Form.Group className="form-group">
                                    <DatePicker
                                        className="form-control"
                                        dateFormat="yyyy-MM-dd"
                                        selected={this.state.endDate}
                                        onChange={this.handleEndDateChange}
                                        placeholderText="End Date"
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={3}>
                                <Button variant="primary" type="submit">Search</Button>
                            </Col>
                        </Row>
                    </Form>

                    <PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (
                                    <ToolkitProvider
                                        keyField="userId"
                                        data={summary}
                                        columns={columns}
                                        search
                                        bootstrap4
                                    >
                                        {
                                            props => (
                                                <div>
                                                    <div className="d-flex flex-wrap align-items-center mb-3 gap-3">

                                                        <div className="d-flex align-items-center">
                                                            <span className="mr-2">Show</span>
                                                            <SizePerPageDropdownStandalone
                                                                className="search-dropdown"
                                                                {...paginationProps}
                                                            />
                                                            <span className="ml-2">items</span>
                                                        </div>

                                                        <div className="d-flex align-items-center gap-2">
                                                            <span className="search-cont">
                                                                <SearchBar {...props.searchProps} />
                                                            </span>

                                                            <ClearSearchButton
                                                                className="btn-primary btn-round"
                                                                {...props.searchProps}
                                                            />
                                                            <ExportCSVButton
                                                                className="export-csv btn-primary"
                                                                {...props.csvProps}
                                                            >
                                                                Export to CSV
                                                            </ExportCSVButton>
                                                        </div>
                                                    </div>

                                                    <div className="table-container">
                                                        <BootstrapTable
                                                            defaultSorted={defaultSorted}
                                                            noDataIndication={() => this.state.isLoading ? <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div> : <div className="text-center p-3">No data available</div>}
                                                            hover
                                                            bordered={true}
                                                            wrapperClasses="table-responsive"
                                                            classes="userlist-table"
                                                            {...props.baseProps}
                                                            {...paginationTableProps}
                                                        />
                                                    </div>

                                                    <div className="d-flex justify-content-center mt-3">
                                                        <PaginationListStandalone {...paginationProps} />
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </ToolkitProvider>
                                )
                            }
                        </PaginationProvider>
                    </div>
            </Card.Body>
            <Modal size="sm" show={this.state.showBillingModal} onHide={this.closeBillingModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Billing Duration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!this.state.loadingBilling ? (
                        <div>
                            <p><strong>Campaign ID:</strong> {this.state.billingDurationData?.campaignId}</p>
                            <p><strong>Billing Duration:</strong> {this.state.billingDurationData?.bd}</p>
                            <p><strong>Absolute Billing Duration:</strong> {this.state.billingDurationData?.abd}</p>
                        </div>
                    ) : (
                        <p>Loading billing details...</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.closeBillingModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Card>)

    }

}